import SupportController from './SupportController';
import SupportDialogController from './support_dialog/SupportDialogController';


angular
  .module('VSPApp')
  .controller('SupportController', SupportController)
  .controller('SupportDialogController', SupportDialogController);
